import { Step } from "react-joyride"
import { TUTORIAL_PROFILE_STEPS } from "./profile"
import { TUTORIAL_ACTIVITES_STEPS } from "./activites"

export const TUTORIAL_GLOBAL_STEPS: Step[] = [...TUTORIAL_PROFILE_STEPS, ...TUTORIAL_ACTIVITES_STEPS]
